// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

//Third Party
import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Pipes
//import { FormatDatePipe } from '../../shared/pipes/formatDatePipe';

//Bootstrap
//import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Config/Globals
import { Enums } from '../../shared/enums.js';
import { appConfig } from '../../shared/appConfig.js';

//Token
import { authToken } from '../../shared/authToken';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CPDManagementComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector:'cpd-management',
    template : '<!--Page content container-->\n    <div style="margin:10px;" data-test-id="content_cpd_management">\n\n        <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n        <div id="mySpacer" style="margin-top:10px;">&nbsp;</div>\n\n        <!--DMS Transactions Grid-->\n        <div class="cpd-ui-row" data-test-id="section_cpd_management_dms_transactions">\n            <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>DMS Transactions</h3></div>\n\n                <div class="cpm-control-div" aria-label="Filters">\n                    <div>Filter By:&nbsp;&nbsp;&nbsp;</div>\n                    <label>Start date</label>\n                    <input type="date"\n                           placeholder="m/d/yyyy"\n                           id="start_date_filter_selector"\n                           name="start_date_filter_selector"\n                           aria-label="Start date filter (format m/d/yyyy)"\n                           [(ngModel)]="_startDateFilter" />\n                    <label>&nbsp;&nbsp;End date</label>\n                    <input type="date"\n                           placeholder="m/d/yyyy"\n                           id="end_date_filter_selector"\n                           name="end_date_filter_selector"\n                           aria-label="End date filter (format m/d/yyyy)"\n                           [(ngModel)]="_endDateFilter" />\n                    <span>&nbsp;&nbsp;</span>\n                    <button type="button"\n                            class="btn btn-primary"\n                            (click)="applyFilters()">\n                        GO\n                    </button>\n                </div>\n\n                <div style="margin-top:10px; position:relative;">\n                    <cas-grid #dmsGrid\n                              summary="DMS Transactions List"\n                              [settings]="_dmsGridSettings"\n                              (onRowUnSelected)="dmsGridRowUnSelected($event)"\n                              (onRowSelected)="dmsGridRowSelected($event)">\n                    </cas-grid>\n\n                </div>\n\n            </div>\n        </div>\n\n        <!--Practice Info Row-->\n        <div class="cpd-ui-row" data-test-id="section_cpd_management_practice_info">\n\n            <!--Practice Info Cell-->\n            <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Asset</h3></div>\n                <div style="margin-top:10px;"></div>\n\n                <!--Code & Name "subrow"-->\n                <div class="cpm-ui-row">\n\n                    <!--Practice Code-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.practice_code?.field_show">\n                        <label for="practice_code" class="cpm-ui-field-left-label">{{_formData?.fields?.practice_code?.field_display}}</label>\n                        <input id="practice_code" name="practice_code" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.practice_code?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.practice_code" />\n                    </div>\n\n                    <!--Practice Name-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.practice_name?.field_show" style="flex-grow:1;">\n                        <label for="practice_name" class="cpm-ui-field-right-label">{{_formData?.fields?.practice_name?.field_display}}</label>\n                        <input id="practice_name" name="practice_name" type="text"\n                               class="cpd-ui-field-readonly" style="min-width:150px; width:80%;"\n                               [attr.readonly]="_formData?.fields?.practice_name?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.practice_name" />\n                    </div>\n\n                </div>\n\n                <!--Dates "subrow"-->\n                <div class="cpm-ui-row">\n\n                    <!--National Standard Release Date-->\n                    <!-- Custom Pipe used here.  See "shared/pipes/formatDatePipe.js" to see what it does-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.dms_nat_std_release_date?.field_show">\n                        <label for="dms_nat_std_release_date" class="cpm-ui-field-left-label">{{_formData?.fields?.dms_nat_std_release_date?.field_display}}</label>\n                        <input id="dms_nat_std_release_date" name="dms_nat_std_release_date" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.dms_nat_std_release_date?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.national_standard_release_date | formatDate" />\n                    </div>\n\n                    <!--National Standard End Date-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.dms_nat_std_end_date?.field_show">\n                        <label for="dms_nat_std_end_date" class="cpm-ui-field-right-label">{{_formData?.fields?.dms_nat_std_end_date?.field_display}}</label>\n                        <input id="dms_nat_std_end_date" name="dms_nat_std_end_date" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.dms_nat_std_end_date?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.national_standard_end_date | formatDate" />\n                    </div>\n\n                    <!--State Standard Adoption Date-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.dms_state_std_adopt_date?.field_show">\n                        <label for="dms_state_std_adopt_date" class="cpm-ui-field-right-label">{{_formData?.fields?.dms_state_std_adopt_date?.field_display}}</label>\n                        <input id="dms_state_std_adopt_date" name="dms_state_std_adopt_date" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.dms_state_std_adopt_date?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.state_standard_adoption_date | formatDate" />\n                    </div>\n\n                    <!--State Standard End Date-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.dms_state_std_end_date?.field_show">\n                        <label for="dms_state_std_end_date" class="cpm-ui-field-right-label">{{_formData?.fields?.dms_state_std_end_date?.field_display}}</label>\n                        <input id="dms_state_std_end_date" name="dms_state_std_end_date" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.dms_state_std_end_date?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.state_standard_end_date | formatDate" />\n                    </div>\n\n                </div>\n\n                <!--Dates "subrow"-->\n                <div class="cpm-ui-row">\n\n                    <!--Practice Unit-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.measurement_unit_id?.field_show">\n                        <label for="measurement_unit_id" class="cpm-ui-field-left-label">{{_formData?.fields?.measurement_unit_id?.field_display}}</label>\n                        <input id="measurement_unit_id" name="measurement_unit_id" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.measurement_unit_id?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.practice_measurement_unit" />\n                    </div>\n\n                    <!--Max Lifespan-->\n                    <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.installed_practice_lifespan_years?.field_show">\n                        <label for="installed_practice_lifespan_years" class="cpm-ui-field-right-label">{{_formData?.fields?.installed_practice_lifespan_years?.field_display}}</label>\n                        <input id="installed_practice_lifespan_years" name="installed_practice_lifespan_years" type="text"\n                               class="cpd-ui-field-readonly" style="width:75px;"\n                               [attr.readonly]="_formData?.fields?.installed_practice_lifespan_years?.field_readOnly ? true : null"\n                               [ngModel]="_selectedRow?.installed_practice_lifespan" />\n                    </div>\n                </div>\n\n                <!--Definition-->\n                <div class="cpm-ui-field-div" [hidden]="!_formData?.fields?.practice_definition?.field_show">\n                    <label for="practice_definition" class="cpm-ui-field-left-label">{{_formData?.fields?.practice_definition?.field_display}}</label>\n                    <textarea id="practice_definition" name="practice_definition" type="text"\n                              class="cpd-ui-field-readonly" rows=3 style="width:90%;"\n                              [attr.readonly]="_formData?.fields?.practice_definition?.field_readOnly ? true : null"\n                              [ngModel]="_selectedRow?.practice_definition">\n                </textarea>\n                </div>\n\n            </div>\n        </div>\n\n        <!--Purposes Grid-->\n        <div class="cpd-ui-row" data-test-id="section_cpd_management_purposes">\n            <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Purposes</h3></div>\n\n                <div style="margin-top:10px; position:relative;">\n                    <cas-grid #purposesGrid\n                              summary="Purposes List"\n                              [settings]="_purposesGridSettings"\n                              (onRowSelected)="purposesGridRowSelected($event)">\n                    </cas-grid>\n\n                </div>\n\n            </div>\n        </div>\n\n        <!--Documents Grid-->\n        <div class="cpd-ui-row" data-test-id="section_cpd_management_documents">\n            <div class="cpd-ui-cell" style="flex-grow:1;">\n\n                <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Documents</h3></div>\n\n                <div style="margin-top:10px; position:relative;">\n                    <cas-grid #documentsGrid\n                              summary="Documents List"\n                              [settings]="_documentsGridSettings"\n                              (onRowSelected)="documentsGridRowSelected($event)">\n                    </cas-grid>\n\n                </div>\n\n            </div>\n        </div>\n\n    </div>\n\n',
    styles : ['.cpm-ui-row{display:flex;margin-bottom:5px}.cpm-ui-field-div{display:flex;margin:0 0 8px 0;align-items:center}.cpm-ui-field-left-label{width:120px;margin-right:10px;text-align:right}.cpm-ui-field-right-label{margin:0 10px;width:100px;text-align:right}.cpm-control-div{display:flex;align-items:center;margin:20px 0 10px 0;font-size:12px}'],
    providers:[ ],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class CPDManagementComponent implements OnDestroy, OnInit, AfterViewInit {

    
    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('dmsGrid') dmsGrid; 
    @ViewChild('documentsGrid') documentsGrid; 
    @ViewChild('purposesGrid') purposesGrid; 
    
    //Class wide member reference for the growls control
    growlBox = null;

    
    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _appConfig = appConfig;
    _authToken = authToken;
    _selectedRow = null;
    _componentName = 'cpdManagement.js';
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'cpd_management'; //Just a shortcut (also helpful for cut & paste)
    _startDateFilter = null;
    _endDateFilter = null;
    _formData = {
        fields: {
            practice_code: {
                field_show: true,
                field_display: "Practice Code",
                field_readOnly: true
            },
            practice_name: {
                field_show: true,
                field_display: "Name",
                field_readOnly: true
            },
            dms_nat_std_release_date: {
                field_show: false,
                field_display: "National Release Date",
                field_readOnly: true
            },
            dms_nat_std_end_date: {
                field_show: false,
                field_display: "National End Date",
                field_readOnly: true
            },
            dms_state_std_adopt_date: {
                field_show: false,
                field_display: "State Adoption Date",
                field_readOnly: true
            },
            dms_state_std_end_date: {
                field_show: false,
                field_display: "State End Date",
                field_readOnly: true
            },
            measurement_unit_id: {
                field_show: true,
                field_display: "Practice Unit",
                field_readOnly: true
            },
            installed_practice_lifespan_years: {
                field_show: true,
                field_display: "Maximum Lifespan",
                field_readOnly: true
            },
            practice_definition: {
                field_show: true,
                field_display: "Practice Definition",
                field_readOnly: true
            }
        }
    }; // { forms:[], actions:[], fields:{} }; from formData2 service

    _title = "CPD Transactions";

    _dmsGridSettings = {
        //cssClasses_Grid:"pv-practicesGrid-grid",
        //cssClasses_Headers:"pv-practicesGrid-columnHeaderRow",
        //hideClearSelectedButton:true,
        hideRefreshButton:true,
        loading:true,
        positionAbsolute:false,
        maxHeight:150,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_code",
        rowIdentityPrefixForJAWS:"Asset Code",
        //showCheckboxColumn:true,
        columns:[
            { fieldName:'practice_code', display:'Asset Code', width:'10%', minWidth:30 },
            { fieldName:'state_county_code', display:'State County Code', width:'20%', minWidth:50 },
            { fieldName:'transaction_date', display:'Transaction Date', width:'20%', minWidth:50, 
                procDataFn: (transDate) => { return this.formatDate(transDate, true); }, dataType: 'date' },
            { fieldName:'practice_name', display:'Asset Name', width:'50%', minWidth:100 }
        ],
        rows:[]
    };

    _documentsGridSettings = {
        hideClearSelectedButton:true,
        hideRefreshButton:true,
        loading:true,
        positionAbsolute:false,
        maxHeight:150,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"nrt_document_name",
        rowIdentityPrefixForJAWS:"Document Name",
        //showCheckboxColumn:false,
        columns:[
            { fieldName:'nrt_document_display', display:'Display', width:'30%', minWidth:100 },
            { fieldName: 'nrt_document_release_date', display: 'Release Date', width: '10%', minWidth: 100, procDataFn: (relDate) => { return this.formatDate(relDate, false); }, dataType: 'date' },
            { fieldName:'nrt_practice_document_type_name', display:'Type', width:'15%', minWidth:50 },
            { fieldName:'nrt_document_mime_type_display', display:'Format', width:'15%', minWidth:50 },
            { fieldName:'nrt_document_keywords', display:'Keywords', width:'30%', minWidth:100, truncate:50, nowrap:true },
        ],
        rows:[]
    };

    _purposesGridSettings = {
        //disableSelection:true,
        hideClearSelectedButton:true,
        hideRefreshButton:true,
        loading:false,
        positionAbsolute:false,
        maxHeight:200,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_purpose_name",
        rowIdentityPrefixForJAWS:"Purpose Name",
        //showCheckboxColumn:false,
        columns:[
            { fieldName:'practice_purpose_cpddms_id', display:'DMS ID', width:'10%', minWidth:50 },
            { fieldName:'practice_purpose_name', display:'Name', width:'70%', minWidth:150 },
            { fieldName: 'practice_purpose_effective_date', display: 'Start Date', width: '20%', minWidth: 50, dataType: 'date' },
        ],
        rows:[]
    };


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(casNavBoxService:CASNavBoxService,
                cpdFormatters: CPDFormatters,
                //formDataService: FormDataService2,
                helpers: Helpers,
                router:Router,
                webServices:WebServices){

        this.constructor.mapParams( this, arguments );

        // Growl Prep
        //--------------------
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({ 
	        appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer definied in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        }); 

        //Handle clicks on the NavBox actions via the navBoxCommService
        var disposer = casNavBoxService.OnActionClicked$.subscribe( action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        //Action Help
        disposer = casNavBoxService.OnActionHelpClicked$.subscribe( action => {
            this.navBoxActionHelpClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Set title 
        //--------------------
        if (this._authToken.IsState()){
            this._title = this._authToken.user.stateName + " - CPD Transactions";   
        }
        else{
            this._title = "National - CPD Transactions";   
        }
        
        // Debugging 
        //--------------
        casNavBoxService.ClearDebugEntries();
    };
    
    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        for (var i=0; i<this._disposalFunctions.length; i++){
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        this.setNavBoxActions();
    }

    ngAfterViewInit() {
        this.set508();
        this.loadDMSTransactions();
        this.loadDocuments();
    }

    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------

    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // applyFilters
    //==================================
    applyFilters() {
        this.loadDMSTransactions();
        this.loadDocuments();
    }

    //==================================
    // dmsGridRowUnSelected
    //==================================
    dmsGridRowUnSelected(row){

        //This grid is single selection, so any unselection is equivalent to a clear
        this._selectedRow = null;

        //Clear purposes
        this._purposesGridSettings.rows = [];

        if (this.dmsGrid.GetSelectedRows().length == 0){
            
            //List emptied, load unfiltered documents
            this.loadDocuments();
        }
    };

    //==================================
    // dmsGridRowSelected
    //==================================
    dmsGridRowSelected(row){

        this.documentsGrid.MarkAsLoading(true);

        //Load the selected row
        this.loadPurposes(row);

        //Load the documents for this user that match the practice code of the selected record
        this.loadDocuments(row.practice_code);
    };

    //==================================
    // documentsGridRowSelected
    //==================================
    documentsGridRowSelected(){
        //console.log("documentsGridRowSelected - row:", row);
    };

    //==================================
    // purposesGridRowSelected
    //==================================
    purposesGridRowSelected(row){
        //console.log("purposesGridRowSelected - row:", row);
    };


    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }

    //==================================
    // loadDMSTransactions
    //==================================
    loadDMSTransactions() {
        this.dmsGrid.MarkAsLoading(true);
        let dateFilters = {
            startDateFilter: this._startDateFilter ? this.formatDate(this._startDateFilter) : null,
            endDateFilter: this._endDateFilter ? this.formatDate(this._endDateFilter) : null
        }
        this.webServices.GetDMSTransactions(dateFilters)
            .then(res => {
                console.log("[{0}:ngOnInit():GetDMSTransactions] - res:".format(this._componentName), res);

                this._dmsGridSettings.rows = res.DTO;
                this.dmsGrid.MarkAsLoading(false);
                this.dmsGrid.GoToFirstPage();
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            })
    }

    //==================================
    // formatDate
    //==================================
    formatDate(dateString, includeTime){
        //Used for internal processing (use the formatDate pipe for the markup/template)
        let formatString = includeTime ? "MM/DD/YYYY HH:mm:ss A" : "MM/DD/YYYY"
        return dateString ? moment(dateString).format(formatString) : null;
    };

    //==================================
    // loadDocuments
    //==================================
    // practiceCode<str>:   //(opt,null)
    loadDocuments(practiceCode){

        //Push to the back of the stack (give the grid a chance to render)
        window.setTimeout(()=>{

            practiceCode = practiceCode || null;
        
            if (this.documentsGrid){ this.documentsGrid.MarkAsLoading(true); }

            this.webServices.GetDMSDocuments(practiceCode)
            .then(res=>{
                console.log("[{0}:ngOnInit():GetDMSDocuments] - res:".format(this._componentName), res);
                this._documentsGridSettings.rows = res.DTO.length > 0 ? res.DTO : [];
                this.documentsGrid.MarkAsLoading(false); //should be done by now
            })
            .catch(err=>{
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.documentsGrid.MarkAsLoading(false);
            })

        },0);

    };

    //==================================
    // loadPurposes
    //==================================
    loadPurposes(row){
    

        //console.log("========== loadPurposes(row)", row);
        //return;

        this.purposesGrid.MarkAsLoading(true);

        //Currently the row object has all the fields that needs to displayed in the practice section
        this._selectedRow = row || null;

        //Load the purposes for the selcted row
        this.webServices.GetDMSPurposes(row.batch_id)
        .then(res=>{
            console.log("[{0}:loadPurposes():GetDMSPurposes] - res:".format(this._componentName), res);

            //Special case with the weird way this table is set up
            if (!res.DTO[0].practice_purpose_cpddms_id){
                res.DTO = [];
            }

            this._purposesGridSettings.rows = res.DTO;
            this.purposesGrid.MarkAsLoading(false);
        })
        .catch(err=>{
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
        })
    };

}//component
